import HeroSection from "./components/HeroSection";
import WhyItWorks from "./components/WhyItWorks";
import AboutRaissa from "./components/AboutRaissa";
import ForWho from "./components/ForWho";
import WhatYouGet from "./components/WhatYouGet";
import HowItWorks from "./components/HowItWorks";
import Pricing from "./components/Pricing";
import Guarantee from "./components/Guarantee";
import FAQ from "./components/FAQ";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";

export default function HomePage() {
  return (
    <div className='min-h-screen bg-white'>
      <HeroSection />
      <WhyItWorks />
      <WhatYouGet />
      <AboutRaissa />
      <ForWho />
      <HowItWorks />
      <Pricing />
      <Guarantee />
      <FAQ />
      <FinalCTA />
      <Footer />
    </div>
  );
}
